import React from "react";
import "./style.css";

const Cross = () => {
  return <div className="cross"></div>;
};

export default Cross;
